import { render, staticRenderFns } from "./ForgetPswForm.vue?vue&type=template&id=be049ad4&scoped=true&"
import script from "./ForgetPswForm.vue?vue&type=script&lang=js&"
export * from "./ForgetPswForm.vue?vue&type=script&lang=js&"
import style0 from "./ForgetPswForm.vue?vue&type=style&index=0&id=be049ad4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be049ad4",
  null
  
)

export default component.exports